<template>
    <div
        v-bind:class="{expanded: expanded, selectors: !expanded}"
        v-on:click.self="expanded = false"
    >
        <div v-bind:class="{'expanded-content': expanded}">
            <a v-if="!expanded" title="Reset" href="./" class="about no-print">
                <font-awesome-icon icon="redo"/>
            </a>
            <span title="Print" v-if="!expanded" v-on:click="openToPrint" class="about no-print">
                <font-awesome-icon icon="print"/>
            </span>
            <AboutPage class="no-print"/>
            <div v-if="expanded">
                <h2>Buildings</h2>
                <p class="no-print">
                    About Buildings
                </p>
            </div>
            <div class="group no-print">
                <div class="control-title">Choose Community:</div>
                <mcdSelect
                        v-bind:mcd="mcd"
                        v-bind:counties="counties"
                        v-on:mcdInput="setMcd($event)"
                        v-on:countiesInput="setCounties($event)"
                />
            </div>
            <div class="group">
                <div class="control-title">Choose Visualization:<span v-if="selectedAmenity !== 'All_Access_Points'"></span></div>
                <select v-model="selectedAmenity" class="name">
                    <option disabled value="">Choose a Style</option>
                    <option
                            v-for="name in amenities"
                            v-bind:key="name"
                            v-bind:value="name">{{amenityNames[name].name}}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import mcdSelect from "./mcdSelect";
    import AboutPage from "./AboutPage";

    export default {
        name: "AmenitySelect",
        components: {mcdSelect, AboutPage},
        props: ['mappedAmenity', 'amenities', 'amenityNames', 'counties', 'mcd', 'data_tables', 'data_table', 'modeNames', 'demographicColumn', 'demographicColumns', 'startExpanded'],
        data: function () {
            return {
                selectedAmenity: this.mappedAmenity,
                expanded: this.startExpanded,
            }
        },
        methods: {
            setMcd: function (id) {
                this.$emit('mcdInput', id)
            },
            setCounties: function (id) {
                this.$emit('countiesInput', id)
            },
            openToPrint: function () {
                let search = window.location.search || '?';
                let counties = this.counties.map(c => '&county=' + c.statevalue).join('');
                window.open(
                    window.location.pathname + search + '&print=true' + counties,
                    "",
                    "width=1000, height=700, dependent=true"
                );
            }
        },
        watch:{
            mappedAmenity: function () {
                this.selectedAmenity = this.mappedAmenity
            },
            selectedAmenity: function () {
                this.$emit('input', this.selectedAmenity)
            },
            expanded: function () {
                this.$emit('expandedInput', this.expanded)
            },
        }
    }
</script>

<style scoped>
    select {
        border-color: #f3f3f3;
    }

    select:focus {
        outline: 0;
        border-color: black;
    }

    select {
        border-radius: 10px;
        min-width: 0;
    }

    select option {
        font-size: 1rem;
    }

    .about {
        float: right;
        padding: 5px;
        color: black;
    }

    @media screen {
        div.expanded {
            position: fixed;
            background: rgba(46, 60, 67, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 3;
            opacity: 1;
            overflow: hidden;
            backdrop-filter: blur(35px);
        }

        .expanded-content {
            background: white;
            max-width: 60%;
            border: #fffcfc solid 2px;
            border-radius: 10px;
            padding: 10px 30px;
            max-height: 80%;
            overflow: auto;
        }
    }

    .control-title {
        font-weight: bold;
        font-size: large;
    }

    .slidecontainer {
        width: 100%;
    }

    .mode-ticks {
        display: grid;
        width: 100%;
        grid-template-columns: min-content min-content min-content min-content;
        justify-content: space-between;
        margin-bottom: -45px;
        padding: 0 calc(29px - .7em);
    }

    @media print {
        .slidecontainer>div {
            display: inline-block;
        }
        .mode-ticks {
            margin-bottom: 0;
            display: inline-block;
        }
    }

    .mode-ticks div {
        text-align: center;
        justify-self: center;
    }

    .slider {
        -webkit-appearance: none;
        width: 100%;
        height: 50px;
        border-radius: 20px;
        background: #d3d3d3;
        outline: none;
        opacity: 0.5;
        -webkit-transition: .2s;
        transition: opacity .2s;
    }

    .slider:hover {
        opacity: 0.3;
    }

    .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 58px;
        height: 65px;
        border-radius: 20px;
        background: #64983D;
        cursor: pointer;
    }

    .slider::-moz-range-thumb {
        width: 58px;
        height: 65px;
        border-radius: 20px;
        background: #64983D;
        cursor: pointer;
    }

    .amenityIcon {
        height: 35px;
        width: 35px;
        vertical-align: bottom;
        margin-left: 7px;
    }

    .mode-label {
        font-size: 0.5em
    }

    .result-button{
        float: right;
        height: 30px;
        background: rgba(100, 152, 61, 0.75);
        border-color: rgba(100, 152, 61, 0.75);
    }

    .group {
        padding: 5px;
    }

    @media print {
        .no-print {
            display: none;
        }
    }

    @media screen and (max-width: 576px) {
        .expanded-content {
            position: relative;
        }

        div.expanded {
            z-index: 33;
        }
    }

    @media screen and (max-width: 1000px) {
        .control-title {
            font-size: small;
            display: inline-block;
        }

        .expanded-content {
            max-width: 80%;
            max-height: 100%;
        }

    }
</style>
